import { createContext } from 'react';

import { PathSegment, TrackingData } from '../../types';

export interface TrackingContextValue {
  path: PathSegment[];
  data: TrackingData;
}

export const TrackingContext = createContext<TrackingContextValue>({
  path: [],
  data: {},
});
